import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UserList from '../components/subscriptions/UserList';

import {
  fetchSubscriptionUsers,
  fetchSubscription,
  doRemoveUser,
  doAddUser,
} from '../actions/subscriptions';

/**
 * Subscription users container
 */

const mapStateToProps = ({subscriptionsById,usersById}, {subscription}) => {
  const pagination = subscriptionsById[subscription.id].users;

  return {
    pagination
  };
}

const mapDispatchToProps = (dispatch, {subscription}) => {
  const handleLoadPage = (limit, token) => {
    return dispatch(fetchSubscriptionUsers(subscription.id, limit, token))
  }
  return {
    handleLoadPage,

    // remove user from this subscription
    handleRemoveUser: (user) => {
      return dispatch(doRemoveUser(subscription.id, user.id))
      // FIXME: dirty
        .then(_ => {
          dispatch(fetchSubscription(subscription.id));  // needed to retrieve a fresh subscription.warning
        }) 
    },
    // add user from this subscription
    handleAddUser: (user) => {
      return dispatch(doAddUser(subscription.id, user.id))
        .then(_=> {
          dispatch(fetchSubscription(subscription.id));
        })
    }
  }
}

const SubscriptionUsers = connect(mapStateToProps, mapDispatchToProps) (UserList);

SubscriptionUsers.propTypes = {
  subscription: PropTypes.object.isRequired
}

export default SubscriptionUsers;




// WEBPACK FOOTER //
// ./src/containers/SubscriptionUsers.js